import { render, staticRenderFns } from "./v-contact-widget-icon.vue?vue&type=template&id=5211e772&scoped=true&"
var script = {}
import style0 from "./v-contact-widget-icon.vue?vue&type=style&index=0&id=5211e772&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5211e772",
  null
  
)

export default component.exports